<template>
  <!-- class="demo-inline-spacing" -->
  <!-- style="display: flex;align-items: flex-end;align-content: center;flex-wrap: wrap;" -->
  <div class="demo-inline-spacing">
    <b-form-checkbox-group
      v-model="data"
      :stacked="option.stacked"
      :options="dictOptions"
      value-field="value"
      text-field="label"
    />
  </div>
</template>

<script>
import { BFormCheckboxGroup } from 'bootstrap-vue'
import { getDicts } from '../utils'

export default {
  components: {
    BFormCheckboxGroup,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: this.getValueAsArray(),
      dictOptions: [],
      dictCode: this.option.dictCode || this.option.dictBizCode,
      stacked: false,
      isInternalChange: false, // 添加内部变更标识
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        // 只有当不是由value变化引起的内部更新时才触发事件
        if (!this.isInternalChange) {
          this.$emit('input', Array.isArray(e) ? e.join(',') : e)
        } else {
          // 重置标识
          this.isInternalChange = false
        }
      },
    },
    'option.dictData': {
      handler(e) {
        if (e) {
          if (e.length > 0) {
            if (this.disabled) {
              this.dictOptions = e.map((el) => ({
                ...el,
                disabled: true,
              }))
            } else {
              this.dictOptions = e
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    'option.dictBizCode': {
      handler(e) {
        if (e) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
    'option.dictCode': {
      handler(e) {
        if (e) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal) {
        // 设置内部变更标识，避免触发emit
        this.isInternalChange = true
        this.data = this.getValueAsArray(newVal)

        // 延迟重置标识，确保下次外部变更能正常触发
        this.$nextTick(() => {
          this.isInternalChange = false
        })
      },
      deep: true,
    },
  },
  mounted() {
    if (this.value) {
      this.initDictOption(this.value)
    }
  },
  methods: {
    getValueAsArray(val) {
      const value = val !== undefined ? val : this.value
      if (value === undefined || value === null) {
        return []
      }

      if (Array.isArray(value)) {
        return value
      }

      if (typeof value === 'string') {
        return value ? value.split(',') : []
      }

      return [value]
    },

    initDictOption(e) {
      if (this.dictCode && this.dictOptions.length <= 0) {
        getDicts(this.option).then((res) => {
          this.dictOptions = res
          // 确保在获取字典后正确设置data
          this.isInternalChange = true
          this.data = this.getValueAsArray(e)
          this.$nextTick(() => {
            this.isInternalChange = false
          })
        })
      } else if (e) {
        this.isInternalChange = true
        this.data = this.getValueAsArray(e)
        this.$nextTick(() => {
          this.isInternalChange = false
        })
      }
    },

    changeDictOption() {
      getDicts(this.option).then((res) => {
        this.dictOptions = res
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
